import { keyframes as o } from "@emotion/react";
const a = o({ from: { opacity: 0 }, to: { opacity: 1 } }), c = o({ from: { opacity: 1 }, to: { opacity: 0 } });
export {
  a as fadeIn,
  c as fadeOut
};
